module.exports = __webpack_public_path__ + "img/32.97550f0f.png";